import { DynamicFormAnswer } from '@api_patient/dynamic_forms_api.service';
import { CellulaFormSubmitData } from '@cellula/react';
import type { QuestionApiModel } from '@visiba/api-vcs-client-v2';
import { FormOption, ValidOptionId } from './_form_option';
import { FormQuestionBase } from './_form_question_base';

export class FormQuestionTypeSingleChoiceRadio extends FormQuestionBase {
	public readonly type = 'SingleChoiceRadio';
	public readonly options: FormOption[];
	public defaultValue: ValidOptionId | undefined = undefined;

	constructor(question: QuestionApiModel) {
		super(question);

		// TODO PAT-426: Allow null?
		this.options = this.parseQuestions(question.Options ?? []);
	}

	// TODO: Use this when not injected anymore...
	// public override getAnswer(formElements: FormElements<string>): AnswerApiModel {
	public getAnswer(pageData: CellulaFormSubmitData): DynamicFormAnswer {
		const formValue: ValidOptionId | null = (pageData[this.id] as ValidOptionId) || null;
		const choice = formValue ? [FormOption.composeOptionId(formValue)] : [];

		return this.createAnswerApiModel({
			choices: choice,
		});
	}

	// TODO: Use this when not injected anymore...
	// public override setDefault(allAnswers: Readonly<AnswerApiModel[]>): void {
	public setDefault(allAnswers: Readonly<DynamicFormAnswer[]>): void {
		const answer = allAnswers.find((answer) => answer.questionId === this.composeQuestionId());
		const option = this.options.find((option) => answer?.choices?.includes(option.composeOptionId()));
		this.defaultValue = option?.id ?? undefined;
	}
}
